import create, { GetState, SetState } from 'zustand';
import { setErrorPersonProvider } from '~/analytics/errorPerson';
import createAuthSlice from './slices/auth';
import createContractSlice from './slices/contract';
import createQuoteSlice from './slices/quote';
import createToastSlice from './slices/toast';
// import createUserSlice from './slices/users'
import { AuthStore } from './slices/auth/types';
import { ContractStore } from './slices/contract/types';
import createPlanSlice from './slices/plan';
import { PlanStore } from './slices/plan/types';
import { QuoteStore } from './slices/quote/types';
import { ToastStore } from './slices/toast/types';

const useStore = create((set, get) => ({
  ...createToastSlice(set as SetState<ToastStore>, get as GetState<ToastStore>),
  ...createAuthSlice(set as SetState<AuthStore>, get as GetState<AuthStore>),
  ...createQuoteSlice(set as SetState<QuoteStore>),
  ...createContractSlice(set as SetState<ContractStore>),
  ...createPlanSlice(set as SetState<PlanStore>)

  // ...createUserSlice(set as SetState<UsersStore>, get as GetState<UsersStore>),
}));

// Pessoa que vai nos erros do PostHog: o que a cotação já tem, depois o cliente e o segurado.
type PersonFields = { name?: string; email?: string; cpf?: string; document?: string };
setErrorPersonProvider(() => {
  const { quote, customer, insured } = useStore.getState() as unknown as Partial<
    Record<'quote' | 'customer' | 'insured', PersonFields>
  >;
  const first = (...values: (string | undefined)[]) => values.find((value) => value?.trim());
  return {
    name: first(quote?.name, customer?.name, insured?.name),
    email: first(quote?.email, customer?.email, insured?.email),
    document: first(quote?.cpf, customer?.document, insured?.document)
  };
});

export const storeState = useStore.getState();
export default useStore;
